module.exports = __webpack_public_path__ + "img/exchange-background.debee14f.png";